/**
 * The role step after «Register» on the sign-in form (SCRUM-970; owner, 01.11.2026: «Регистрирует а потом выбор роли»).
 *
 * Making the account changes the session, and the shell (`app/app-shell.ts#resolveEffectiveRoute`) answers a signed-in person on
 * `/login` by sending him on at once. While this is held, it leaves him on the sign-in card, which shows the «I am a…» step; the
 * card lets go on «Continue». In memory only: a reload simply skips the step — the role stays optional, as on the sign-up form.
 */
let held = false;

export function holdLoginForRoleStep(on: boolean): void {
  held = on;
}

export function loginHeldForRoleStep(): boolean {
  return held;
}
